import React, { useState, useEffect } from "react";
import { Button } from "primereact/button";
import { Helmet } from "react-helmet";

import background2 from "../../new_Images/OtherComponents/WhyClientsChooseUs.png";
import Ourpartnerimg from "../../new_Images/OtherComponents/18.png";

import A3Teach1 from "../images/a3-4.png";
import Wylth2 from "../images/wylth.png";
import Cigniti from "../images/Cigniti.png";
import Natinoal from "../images/Natinoal.png";
import DvritTech from "../images/DVRITTechLogoNoBG.png";
import AVCS from "../images/AVCSImage.png";
import Kidschoice from "../images/KidsChoiceImage.png";

import TestimonialSlider from "./testimonial";
import "../../App.css";

function Clients() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const openInNewTab = (url) => {
    const newTab = window.open(url, "_blank");
    if (newTab) newTab.focus();
  };

  const backgroundImageStyle = {
    backgroundImage: `url(${background2})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    width: "100%",
    marginTop: "35px",
    padding: "41px 0px",
    backgroundColor: "rgba(64, 3, 35, 0.8)",
  };

  return (
    <>
      <Helmet>
        <title>Our Clients | Clota Technologies</title>
        <meta
          name="description"
          content="See why global brands like Wylth, Cigniti, DVRIT Tech and more choose Clota Technologies as their trusted digital partner."
        />
        <meta
          name="keywords"
          content="clients, Clota Technologies, Wylth, Cigniti, Employee Management, IT solutions, software partners"
        />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Clota Technology" />
        <link rel="canonical" href="https://www.clotatech.com/Clients" />
      </Helmet>

      {/* <div>
        <img
          src={Ourpartnerimg}
          alt="Our Partners"
          className="w-full homebanner"
        />
      </div> */}

      <div className="banner-container">
        <img src={Ourpartnerimg} className="banner-image" alt="Banner" />

        {/* Centered Content */}
        <div className="banner-content">
          <div className="banner-text">
            <h1 className="banner-heading">Our Client's</h1>
            <p>
              Explore how we help our clients succeed and drive
              <br />
              their digital transformation.
            </p>
          </div>
        </div>
      </div>

      <div className="grid p-4 justify-content-center">
        {/* A3Tech */}
        <div className="col-12 md:col-6 lg:col-4 p-3 ">
          <div className="surface-card border-round shadow-2 p-4 text-center card-flex-client">
            <img
              src={A3Teach1}
              alt="A3Tech"
              style={{
                height: "120px",
                display: "block",
                marginLeft: "auto",
                marginRight: "auto",
                marginBottom: "1rem",
              }}
            />
            <p className="text-left" style={{ fontStyle: "italic" }}>
              Financial advisors with passion, hunger, and drive are our
              partners. We offer the most complete Platform as a Service (PaaS)
              for financial advisers.
              <br />
              <br />
              A3Tech Pte Ltd 60 Albert Street, #14-01 OG Albert Complex,
              Singapore 189969 info@a3tech.com
            </p>
            <div className="card-footer-client">
              <Button
                label="Visit"
                className="mt-3 btn-styles "
                onClick={() => openInNewTab("https://www.a3tech.com/")}
              />
            </div>
          </div>
        </div>

        {/* Wylth */}
        <div className="col-12 md:col-6 lg:col-4 p-3">
          <div className="surface-card border-round shadow-2 p-4 text-center card-flex-client">
            <img
              src={Wylth2}
              alt="Wylth"
              style={{
                height: "120px",
                display: "block",
                marginLeft: "auto",
                marginRight: "auto",
                marginBottom: "1rem",
              }}
            />
            <p className="text-left" style={{ fontStyle: "italic" }}>
              Wylth® is a unified multi-asset platform that aims to serve all
              the needs of an Independent Financial Advisor / Mutual Fund
              Distributor.
              <br />
              <br />
              Wylth® Singapore 60 Albert Street, #14-01 OG Albert Complex,
              Singapore 189969 contact@wylth.com
            </p>
            <div className="card-footer-client">
              <Button
                label="Visit"
                className="mt-3 btn-styles"
                onClick={() => openInNewTab("https://www.wylth.com/")}
              />
            </div>
          </div>
        </div>

        {/* Cigniti */}
        <div className="col-12 md:col-6 lg:col-4 p-3">
          <div className="surface-card border-round shadow-2 p-4 text-center card-flex-client">
            <img
              src={Cigniti}
              alt="Cigniti"
              style={{
                height: "120px",
                display: "block",
                marginLeft: "auto",
                marginRight: "auto",
                marginBottom: "1rem",
              }}
            />
            <p className="text-left" style={{ fontStyle: "italic" }}>
              Cigniti Technologies is a global leader in providing AI-driven,
              IP-led strategic digital assurance, software quality engineering,
              software testing, automation and consulting services.
              <br />
              <br />
              Hyderabad, India – 500081 +91 40 4038 2255
            </p>

            <div className="card-footer-client">
              <Button
                label="Visit"
                className="mt-3 btn-styles"
                onClick={() => openInNewTab("https://www.cigniti.com/")}
              />
            </div>
          </div>
        </div>

        {/* National Commercial Bank */}
        <div className="col-12 md:col-6 lg:col-4 p-3">
          <div className="surface-card border-round shadow-2 p-4 text-center card-flex-client">
            <img
              src={Natinoal}
              alt="National Bank"
              style={{
                height: "120px",
                display: "block",
                marginLeft: "auto",
                marginRight: "auto",
                marginBottom: "1rem",
              }}
            />
            <p className="text-left" style={{ fontStyle: "italic" }}>
              National Commercial Bank Jamaica Limited offers a wide range of
              services including loans, cards, and foreign currency services.
              <br />
              <br />
              32 Trafalgar Road, Kingston 10 Jamaica W.I
            </p>

            <div className="card-footer-client">
              <Button
                label="Visit"
                className="mt-3 btn-styles"
                onClick={() => openInNewTab("https://www.jncb.com/")}
              />
            </div>
          </div>
        </div>

        {/* DVRIT Tech */}
        <div className="col-12 md:col-6 lg:col-4 p-3">
          <div className="surface-card border-round shadow-2 p-4 text-center card-flex-client">
            <img
              src={DvritTech}
              alt="Dvrit Tech"
              style={{
                height: "120px",
                display: "block",
                marginLeft: "auto",
                marginRight: "auto",
                marginBottom: "1rem",
              }}
            />
            <p className="text-left" style={{ fontStyle: "italic" }}>
              DVRIT Tech unites some of the brightest minds to innovate and push
              technological boundaries.
              <br />
              <br />
              16 Commerce Square, Nottingham NG1 1HS +44 7555 995630
              info@dvrittech.co.uk
            </p>
            <div className="card-footer-client">
              <Button
                label="Visit"
                className="mt-3 btn-styles"
                onClick={() => openInNewTab("https://dvrittech.co.uk/")}
              />
            </div>
          </div>
        </div>

        {/* AV-CS */}
        <div className="col-12 md:col-6 lg:col-4 p-3">
          <div className="surface-card border-round shadow-2 p-4 text-center card-flex-client">
            <img
              src={AVCS}
              alt="AV-CS"
              style={{
                height: "120px",
                display: "block",
                marginLeft: "auto",
                marginRight: "auto",
                marginBottom: "1rem",
              }}
            />
            <p className="text-left" style={{ fontStyle: "italic" }}>
              AV-CS provides consultancy, coaching & support. Consultancy,
              coaching & support by AV-CS.
              <br />
              <br />
              Hyderabad, Telangana, India +91 9100-030-567 team@av-cs.in
            </p>
            <div className="card-footer-client">
              <Button
                label="Visit"
                className="mt-3 btn-styles"
                onClick={() => openInNewTab("https://av-cs.in/")}
              />
            </div>
          </div>
        </div>

        {/* Kids Choice */}
        <div className="col-12 md:col-6 lg:col-4 p-3">
          <div className="surface-card border-round shadow-2 p-4 text-center card-flex-client">
            <img
              src={Kidschoice}
              alt="Kids Choice"
              style={{
                height: "120px",
                display: "block",
                marginLeft: "auto",
                marginRight: "auto",
                marginBottom: "1rem",
              }}
            />

            <p className="text-left" style={{ fontStyle: "italic" }}>
              Kids Choice offers quality toys and play-based learning tools.
              Toys and learning tools for growing minds.
              <br />
              <br />
              Geeta puri Chauraha 'khargapur gomti nagar EXTN Lucknow (India)
            </p>
            <div className="card-footer-client">
              <Button
                label="Visit"
                className="mt-3 btn-styles"
                onClick={() => openInNewTab("https://kidschoice.co.in/")}
              />
            </div>
          </div>
        </div>
      </div>

      {/* WHY CLIENTS CHOOSE US SECTION */}
      <div className="text-center mt-5 px-5 py-2" style={backgroundImageStyle}>
        <div className="text-center text-white mb-5">
          <h1 style={{ fontFamily: "rockwell", color: "#01579b" }}>
            <b>REASONS WHY CLIENTS CHOOSE US!</b>
          </h1>
        </div>

        <div className="grid justify-content-center text-center mt-5 px-5 py-2">
          {[
            {
              label: "WE ARE ALWAYS AVAILABLE FOR YOU",
              tooltip:
                "Customers choose us for quality, affordability, and accessibility—via phone, email, or text for urgent needs.",
            },
            {
              label: "WE FOLLOW PROVEN PROCESSES",
              tooltip:
                "Our designers, coders, and managers work closely to bring your vision to life.",
            },
            {
              label: "WE FOCUS ON HOW IT WILL PROFIT YOUR BUSINESS",
              tooltip:
                "We create client-focused strategies to drive impact and revenue.",
            },
            {
              label: "WE DELIVER ON TIME ON BUDGET",
              tooltip:
                "We build websites, code apps, and run campaigns efficiently and on budget.",
            },
          ].map((item, idx) => (
            <div className="col-12 md:col-6 lg:col-3 p-2" key={idx}>
              <Button
                severity="info"
                className="w-full"
                tooltip={item.tooltip}
                tooltipOptions={{
                  position: isMobile ? "top" : idx >= 2 ? "left" : "right",
                  className: "fixed-tooltip",
                }}
                style={{
                  fontFamily: "rockwell",
                  height: "100%",
                  padding: "1rem",
                }}
              >
                {item.label}
              </Button>
            </div>
          ))}
        </div>
      </div>

      {/* CLIENT TESTIMONIAL */}
      {/* <div className="text-center mt-6">
        <h1 className="Text-Gradient" style={{ fontFamily: "rockwell" }}>
          <b>What Clients Say!!</b>
        </h1>
      </div>

      <div className="grid p-4 shadow-2 border-round m-4">
        <div className="col-12 md:col-6 text-center">
          <img
            src={Wylth2}
            alt="Wylth"
            style={{ height: "120px", width: "300px" }}
          />
        </div>
        <div className="col-12 md:col-6">
          <p style={{ fontStyle: "italic" }}>
            We began working with Clota Technologies since Feb 2022. Fantastic
            Database Support Partner, trustworthy, highly skilled and
            experienced team members. We've relied on them exclusively and look
            forward to continuing that relationship.
          </p>
          <p className="Text-Gradient">
            <b>
              Siddhesh Sawant
              <br />
              Client
            </b>
          </p>
        </div>
      </div> */}

      <TestimonialSlider />
    </>
  );
}

export default Clients;
